/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_DimensionsInputs */

const en_field_dimensions = /** @type {(inputs: Field_DimensionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dimensions (LxWxH)`)
};

const es_field_dimensions = /** @type {(inputs: Field_DimensionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dimensiones (LxAxA)`)
};

const fr_field_dimensions = /** @type {(inputs: Field_DimensionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dimensions (LxlxH)`)
};

const de_field_dimensions = /** @type {(inputs: Field_DimensionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abmessungen (LxBxH)`)
};

const ja_field_dimensions = /** @type {(inputs: Field_DimensionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`寸法 (LxWxH)`)
};

const zh_field_dimensions = /** @type {(inputs: Field_DimensionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尺寸 (长x宽x高)`)
};

const ar_field_dimensions = /** @type {(inputs: Field_DimensionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الأبعاد (طول×عرض×ارتفاع)`)
};

const id_field_dimensions = /** @type {(inputs: Field_DimensionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dimensi (PxLxT)`)
};

const it_field_dimensions = /** @type {(inputs: Field_DimensionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dimensioni (LxPxA)`)
};

const ru_field_dimensions = /** @type {(inputs: Field_DimensionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Размеры (ДxШxВ)`)
};

const pt_field_dimensions = /** @type {(inputs: Field_DimensionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dimensões (CxLxA)`)
};

const ko_field_dimensions = /** @type {(inputs: Field_DimensionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`크기 (가로x세로x높이)`)
};

/**
* | output |
* | --- |
* | "Dimensions (LxWxH)" |
*
* @param {Field_DimensionsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_dimensions = /** @type {((inputs?: Field_DimensionsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_DimensionsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_dimensions(inputs)
	if (locale === "es") return es_field_dimensions(inputs)
	if (locale === "fr") return fr_field_dimensions(inputs)
	if (locale === "de") return de_field_dimensions(inputs)
	if (locale === "ja") return ja_field_dimensions(inputs)
	if (locale === "zh") return zh_field_dimensions(inputs)
	if (locale === "ar") return ar_field_dimensions(inputs)
	if (locale === "id") return id_field_dimensions(inputs)
	if (locale === "it") return it_field_dimensions(inputs)
	if (locale === "ru") return ru_field_dimensions(inputs)
	if (locale === "pt") return pt_field_dimensions(inputs)
	return ko_field_dimensions(inputs)
});